import dayjs from "dayjs";
import { API_WAREHOUSE_SUMMARY } from "shared/constants";
import { isBlankOrNull } from "utils";

const deepClone = obj => {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(deepClone);
  }
  const clonedObj = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      clonedObj[key] = deepClone(obj[key]);
    }
  }
  return clonedObj;
};

const formatRowWareHouseSummary = dataRaw => {
  try {
    let data = [];
    let rPkg = [];
    if (!dataRaw?.length) {
      console.log("data not found");
      return;
    }
    dataRaw.forEach((val, index) => {
      const row = {
        no: index + 1,
        [API_WAREHOUSE_SUMMARY.ROW_NUMBER]: val.rowNumber,
        [API_WAREHOUSE_SUMMARY.SHIPMENT_CODE]: val.shipmentCd,
        [API_WAREHOUSE_SUMMARY.CONTAINER_NO]: val.containerNo,
        [API_WAREHOUSE_SUMMARY.ALLOCATE_STATUS]: val.allocateStatus,
        [API_WAREHOUSE_SUMMARY.READY_FOR_DATE]: val.readyForDt,
        [API_WAREHOUSE_SUMMARY.WAREHOUSE_ID]: val.whCompanyAbbrId,
        [API_WAREHOUSE_SUMMARY.WAREHOUSE_ABBR]: val.whCompanyAbbr,
        [API_WAREHOUSE_SUMMARY.WARE_HOUSE_NAME]: val.whImpExpCd,
        [API_WAREHOUSE_SUMMARY.WARE_HOUSE_IMP_EXP_CD]: val.whImpExpCd,
        [API_WAREHOUSE_SUMMARY.PLANT_ID]: val.whPlantId,
        [API_WAREHOUSE_SUMMARY.ALLOCATE_DATE]: val.allocateDt,
        [API_WAREHOUSE_SUMMARY.UPDATE_DATE]: val.updateDt,
        [API_WAREHOUSE_SUMMARY.WAREHOUSE_SUPPORT]: val.wareHouseSupport,
      };
      val.rPkg.forEach(item => {
        row[item.key] = parseInt(item.qty);
        if (!rPkg.includes(item.key)) return rPkg.push(item.key);
      });
      data.push(row);
    });
    return { data, rPkg };
  } catch (error) {
    console.error(error);
  }
};
const formatRowUpdated = (rowSelectionModel, getWarehouse) => {
  if (!rowSelectionModel.length) return [];

  const data = rowSelectionModel?.map(item => ({
    [API_WAREHOUSE_SUMMARY.SHIPMENT_CODE]: !item?.shipmentCd ? "" : item?.shipmentCd,
    [API_WAREHOUSE_SUMMARY.CONTAINER_NO]: !item?.containerNo ? "" : item?.containerNo,
    [API_WAREHOUSE_SUMMARY.ALLOCATE_STATUS]: !item?.allocateStatus ? "" : item?.allocateStatus,
    [API_WAREHOUSE_SUMMARY.WARE_HOUSE_NAME]: !item?.plantId ? "" : getWarehouse(item?.plantId),
    [API_WAREHOUSE_SUMMARY.PLANT_ID]: !item?.plantId ? "" : item?.plantId,
    [API_WAREHOUSE_SUMMARY.UPDATE_DATE]: !item?.updateDt ? "" : item?.updateDt,
    [API_WAREHOUSE_SUMMARY.ALLOCATE_DATE]: !item?.allocateDt
      ? ""
      : dayjs(item?.allocateDt, "DD/MM/YYYY").format("YYYY-MM-DD"),
  }));

  return data;
};

const transformObjectGraph = entryData => {
  const { data } = entryData;
  const graphData = [];

  if (!data) {
    console.error("Invalid input data format.");
    return [];
  }

  const warehouseList = Object.keys(data);
  if (warehouseList === null || warehouseList?.length <= 0) {
    console.error("No data graph found");
    return [];
  }

  // Check if data exist
  for (const warehouse of warehouseList) {
    const record = data[`${warehouse}`];
    const label = record?.Label;
    const plantId = record?.PlantId;
    const dataSet = record?.DataSet;

    const rPkgTypeList = [];
    for (const [rPkgTypeKey, rPkgTypeValue] of Object.entries(dataSet)) {
      const dateQtyList = [];

      const dates = rPkgTypeValue.forecastDt || [];
      const mins = rPkgTypeValue.min || [];
      const max = rPkgTypeValue.max || [];
      const endingBalances = rPkgTypeValue.data || [];
      const updateEnding = rPkgTypeValue.ending || [];
      // Determine the maximum length among the arrays
      const maxLength = rPkgTypeValue.data?.length;

      // Iterate over each date entry
      for (let i = 0; i < maxLength; i++) {
        dateQtyList.push({
          forecastDt: dates[i] || null,
          min: mins[i] || null,
          max: max[i] || null,
          endingBalance: endingBalances[i] || null,
          newEndingBalance: updateEnding[i] || null,
        });
      }

      rPkgTypeList.push({
        rPkgType: rPkgTypeKey,
        dateQtyList,
      });
    }
    graphData.push({
      whImpExpCd: label,
      plantId: plantId,
      rPkgTypeList,
    });
  }
  return graphData;
};

const simulateGraph = (graphData, rows, rPkgs, isFirstCalculate) => {
  const mapIdxOfDate = {};
  const tableData = {};
  try {
    const tempGraphData = deepClone(graphData);
    const { data, forecastDateList, oriData } = tempGraphData;
    console.log("isFirstCalculate: ", isFirstCalculate);
    // console.log("rows: ", rows);
    forecastDateList.forEach((date, index) => (mapIdxOfDate[date] = index));

    for (const rPkg of rPkgs) {
      for (const row of rows) {
        let warehouse = row?.whImpExpCd;
        // let warehouse = row.wareHouseName;
        let allocateDt = row.allocateDt;
        if (isBlankOrNull(warehouse)) {
          warehouse = row?.wareHouseName;
          allocateDt = row?.allocateDt;
        }
        let qty = row[rPkg];
        let dayMonthAllocateDt = dayjs(allocateDt, "DD/MM/YYYY").format("DD/MM");

        if (!isBlankOrNull(mapIdxOfDate[dayMonthAllocateDt])) {
          if (isBlankOrNull(tableData[warehouse])) {
            tableData[warehouse] = {};
          }
          if (isBlankOrNull(tableData[warehouse][rPkg])) {
            tableData[warehouse][rPkg] = {};
          }
          if (isBlankOrNull(tableData[warehouse][rPkg][dayMonthAllocateDt])) {
            tableData[warehouse][rPkg][dayMonthAllocateDt] = 0;
          }
          tableData[warehouse][rPkg][dayMonthAllocateDt] += parseInt(qty);
        }
      }
    }
    console.log("tableData: ", tableData);
    // const totalWhData = Object.keys(data).length;
    // let iCheck = 0;
    const whKeys = Object.keys(data);
    // console.log("warehouse keys", whKeys);
    for (const keyWareHouse of whKeys) {
      const rPkgTypeKeys = Object.keys(data[keyWareHouse].DataSet);
      // console.log("keyPkgType", rPkgTypeKeys);
      for (const keyPkgType of rPkgTypeKeys) {
        let newOverRequire = 0;
        let ending = 0;
        const keysDt = Object.keys(mapIdxOfDate);
        for (const index in keysDt) {
          const keyDt = keysDt[index];

          if (!isBlankOrNull(tableData[keyWareHouse])) {
            if (index == 0) {
              newOverRequire = data[keyWareHouse].DataSet[keyPkgType].lastOverRequire[index];
              ending = data[keyWareHouse].DataSet[keyPkgType].beginningBalance[index];
            }

            let confirm = 0;
            if (!isBlankOrNull(tableData[keyWareHouse][keyPkgType])) {
              if (!isBlankOrNull(tableData[keyWareHouse][keyPkgType][keyDt])) {
                confirm = tableData[keyWareHouse][keyPkgType][keyDt];
              }
            }
            const dataPkgType = data[keyWareHouse].DataSet[keyPkgType];

            const dailyUsage = dataPkgType.dailyUsage[index];
            const domestic = dataPkgType.domestic[index];
            const newProd = dataPkgType.newProd[index];
            const repoIn = dataPkgType.repoIn[index];
            const repoOut = dataPkgType.repoOut[index];
            const temp =
              parseInt(dailyUsage) - parseInt(domestic) - parseInt(newProd) - parseInt(repoIn) + parseInt(repoOut);
            const require = temp - parseInt(newOverRequire);
            // console.log(
            //   `Require(${require}) = [ dailyUsage(${dailyUsage}) - domestic(${domestic}) - newProd(${newProd}) - repoIn(${repoIn}) - repoOut(${repoOut}) ] + newOverRequire(${newOverRequire})`
            // );
            // console.log("");
            // console.log(
            //   `Ending = ending(${ending}) - require(${require}) + confirm(${confirm}) - newOverRequire(${newOverRequire})`
            // );
            ending = ending - require + confirm - newOverRequire;
            // console.log(`Ending = ${ending}`);
            // console.log("");
            newOverRequire = confirm - require;
            // console.log(`OverRequire = confirm(${confirm}) - require(${require})`);

            data[keyWareHouse].DataSet[keyPkgType].ending[index] = ending;
            if (isFirstCalculate) {
              data[keyWareHouse].DataSet[keyPkgType].data[index] = ending;
            }
          } else {
            data[keyWareHouse].DataSet[keyPkgType].data[index] =
              oriData[keyWareHouse].DataSet[keyPkgType].ending[index];
          }
        }
      }
    }
    return tempGraphData;
  } catch (error) {
    console.error(error);
  }
};
export { formatRowWareHouseSummary, formatRowUpdated, simulateGraph, transformObjectGraph };
